import React, { useEffect, useRef, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import { TListingClient } from 'types/TListing';

type TAdsenseAppProps = {
  environment: any;
  appState: {
    listing: {
      title: TListingClient['title'];
    };
  };
};

let AdsenseForSearch;

const AdsenseApp = ({ appState, environment }: TAdsenseAppProps) => {
  const {
    listing: { title },
  } = appState;
  const adsenseSectionRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const elementRef = adsenseSectionRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            (async () => {
              try {
                AdsenseForSearch = (
                  await import(/* webpackChunkName: "adsenseForSearch" */ './components/AdsenseForSearch')
                ).default;
                setIsLoaded(true);
              } catch {}
            })();
          }
        });
      },
      {
        rootMargin: '0px 0px 300px 0px',
      },
    );

    if (elementRef) {
      observer.observe(elementRef);
    }

    return () => {
      if (elementRef) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <EnvironmentProvider value={environment}>
      <div className="Adsense-container" ref={adsenseSectionRef}>
        {isLoaded && <AdsenseForSearch title={title} />}
      </div>
    </EnvironmentProvider>
  );
};
export default AdsenseApp;
